import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import Grid from '@material-ui/core/Grid';

import TaskIcon from '../../../assets/icons/TaskIcon';
import FormIcon from '../../../assets/icons/FormIcon';
import SurgeonIcon from '../../../assets/icons/SurgeonIcon';
import HospitalIcon from '../../../assets/icons/HospitalIcon';
import CaseReportingIcon from '../../../assets/icons/CaseReportingIcon';
import MoneyBagIcon from '../../../assets/icons/MoneyBagIcon';

import { routes } from '../../../constants';
import { roleNames } from '../../../constants/userRoles';

import './customers-page.scss';

const { ADMIN, SALES_REP, PRACTICE_MANAGER } = roleNames;
const toolsReportingRoles = [ADMIN, SALES_REP, PRACTICE_MANAGER];
// const statusReportRoles = [ADMIN, SALES_REP];

const customersOptions = [
  {
    title: 'Surgeons',
    subTitle: 'Manage surgeon preferences',
    icon: <SurgeonIcon className='option-icn' />,
    url: routes.TOOLS_SURGEONS
  },
  {
    title: 'Hospitals',
    subTitle: 'Manage hospital contacts & notes',
    icon: <HospitalIcon className='option-icn' />,
    url: routes.TOOLS_HOSPITALS
  },
  {
    title: 'Tasks',
    subTitle: 'Create and manage your tasks',
    icon: <TaskIcon className='option-icn' />,
    url: routes.TOOLS_TASKS
  },
  {
    title: 'Forms',
    subTitle: 'Add and manage your forms',
    icon: <FormIcon className='option-icn' />,
    url: routes.TOOLS_FORMS
  },
  {
    title: 'Case Reporting',
    subTitle: 'Review visible case activity',
    icon: <CaseReportingIcon className='option-icn' />,
    url: routes.TOOLS_CASE_REPORTING,
    allowedRoles: toolsReportingRoles,
  },
  {
    title: 'Billing Reporting',
    subTitle: 'Review visible billing activity',
    icon: <MoneyBagIcon className='option-icn' />,
    url: routes.TOOLS_BILLING_REPORTING,
    allowedRoles: toolsReportingRoles,
  },
  // {
  //   title: 'Status Report',
  //   subTitle: 'Snapshot of activity',
  //   icon: <CaseReportingIcon className='option-icn' />,
  //   url: routes.TOOLS_STATUS_REPORT,
  //   allowedRoles: statusReportRoles,
  // },
];

const CustomersPage = () => {
  const tenantColor = useSelector((state) => state.tenant.currentTenant.colorPrimary);
  const currentUser = useSelector((state) => state.user.currentUser);
  const visibleOptions = customersOptions.filter((option) => !option.allowedRoles || option.allowedRoles.includes(currentUser?.role));

  return (
    <div className='page-container flex-1'>
      <div className='page-title'>
        Tools
      </div>

      <div className='customers-page__body'>
        <Grid container spacing={1}>
          {
            visibleOptions.map(option => (
              <Grid key={option.title} item xs={12} sm={12} md={4}>
                <Link to={option.url}>
                  <div
                    className='customers-page-option'
                    key={`${option.title}_${Math.random()}`}
                    style={{ '--colorHover': `${tenantColor}` }}
                  >
                    <span className='option-title'>{option.title}</span>
                    <span className='option-sub-t'>{option.subTitle}</span>
                    <div className='option-icn-cnt'>
                      <span>{React.cloneElement(option.icon, { color: 'var(--app-text)' })}</span>
                    </div>
                  </div>
                </Link>
              </Grid>
            ))
          }
        </Grid>
      </div>
    </div>
  );
};

export default CustomersPage;
